import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=1f0c22ff&scoped=true&"
import script from "./DeviceManagement.vue?vue&type=script&lang=js&"
export * from "./DeviceManagement.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagement.vue?vue&type=style&index=0&id=1f0c22ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c22ff",
  null
  
)

export default component.exports